import { usePropertyNumberUnits } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { useState } from 'react';

interface UnitTypeProps {
    propertyGuid: string;
    required: boolean;
    minimumUnits?: number;
    isReview?: boolean;
}

export const Units: React.FC<UnitTypeProps> = ({ propertyGuid, required, minimumUnits, isReview = false }) => {
    const label = 'Units';
    const [numberUnits, set_numberUnits] = usePropertyNumberUnits(propertyGuid);

    const [helperText, set_helperText] = useState<string>('');
    const handleNumberConstructionUnits = (newvalue: number) => {
        const result = Number(newvalue) || undefined;
        set_numberUnits(result);
    };

    const onKeyUp = (e: any) => {
        const value = e.event.currentTarget.value;
        if (value < 5) {
            set_helperText('Select different structure type for less than five');
        } else {
            set_helperText('');
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={numberUnits}
                />
            ) : (
                <NumberBox
                    value={numberUnits}
                    onChange={handleNumberConstructionUnits}
                    label={label}
                    required={required}
                    min={minimumUnits}
                    onKeyUp={onKeyUp}
                    helperText={helperText}
                />
            )}
        </>
    );
};
